import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-orders-header',
  templateUrl: './orders-header.component.html',
  styleUrls: ['./orders-header.component.scss'],
})
export class OrdersHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();
}
